function isAdminRole() {
    const role = JSON.parse(localStorage.getItem('role') || 'null')
    const roleName = role && typeof role === 'object' ? role.name : role
    return roleName === 'admin' || roleName === 'super-admin'
}

export default [
    {
        path: '/statistiques',
        name: 'Statistiques',
        component: () => import('@/views/Statistics/StatisticsDashboard.vue'),
        meta: { permission: 'company.statistics' }
    },
    {
        path: '/statistiques/config',
        name: 'StatisticsConfig',
        component: () => import('@/views/Statistics/StatisticsConfig.vue'),
        meta: { permission: 'company.statistics' },
        beforeEnter(to, from, next) {
            if (isAdminRole()) next()
            else next({ name: 'Page403' })
        }
    }
]
